var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "cancelmodal",
    staticClass: "modify-modal modify-modal__cancel",
    attrs: {
      value: _vm.isOpen,
      variant: "default",
      "no-footer": "",
      "aria-labelled-by": "modify-cancel-modal-title",
    },
    on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "title",
                  attrs: { id: "modify-cancel-modal-title" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.ModifyReservationPopupTitle) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function (ref) {
            var deactivate = ref.deactivate
            return [
              _c("div", { staticClass: "modify-modal__cancel-fees" }, [
                _c("span", { staticClass: "cancel-icon" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.ModifyReservationPopupCancelFeesMessage)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "modify-modal__cancel-list" },
                _vm._l(_vm.confirmedReservations, function (item, index) {
                  return _vm.currentReservationData.reservations
                    ? _c(
                        "li",
                        {
                          key: item.id,
                          staticClass: "modify-modal__cancel-list-item form",
                          class: { "single-room": !_vm.isMultiRoomReservation },
                        },
                        [
                          _c(
                            "label",
                            {
                              class: { disabled: !item.isCancellable },
                              attrs: { for: item.id },
                            },
                            [
                              _vm.isMultiRoomReservation
                                ? _c("input", {
                                    attrs: {
                                      id: item.id,
                                      type: "checkbox",
                                      name: item.id,
                                      disabled: !item.isCancellable,
                                    },
                                    domProps: {
                                      checked: !_vm.isMultiRoomReservation,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateSelectedRooms(
                                          $event,
                                          item.id,
                                          {
                                            ConfirmationNumber: item.id,
                                            Itinerary: item.itinerary,
                                            HotelCode: item.hotelCode,
                                          }
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", { staticClass: "room-number" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.modifyBookingPropData
                                        .ModifyReservationRoomTitle
                                    ) +
                                      "\n              " +
                                      _vm._s(item.roomNumberOrder)
                                  ),
                                ]),
                                _c("span", [_vm._v(": ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(item.roomStays[0].roomName) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          !item.isCancellable
                            ? _c(
                                "v-dropdown",
                                {
                                  staticClass:
                                    "tooltip tooltip-variant--modify-edit-modal",
                                  attrs: {
                                    "popper-class": "booking-modify-tooltip",
                                    placement: "top",
                                    distance: 22,
                                    skidding: 0,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "popper",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tooltip-variant--modify-edit-modal tooltip-content",
                                              },
                                              [
                                                _c("span", {
                                                  directives: [
                                                    {
                                                      name: "close-popper",
                                                      rawName: "v-close-popper",
                                                    },
                                                  ],
                                                  staticClass: "icon-close",
                                                  attrs: {
                                                    "aria-label": "close",
                                                    tabindex: "0",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "tooltip-body",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      item.cancelPenaltiesText
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("button", {
                                    staticClass: "tooltip-icon icon-info",
                                    attrs: {
                                      role: "presentation",
                                      "aria-label": item.cancelPenaltiesText,
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "button-wrapper form-submit" }, [
                _c(
                  "button",
                  {
                    staticClass: "button--primary black size-md",
                    class: [
                      {
                        disabled:
                          !_vm.selectedRoomsToCancel.length &&
                          _vm.isMultiRoomReservation,
                      },
                      { loading: _vm.cancelReservationLoading },
                    ],
                    attrs: {
                      disabled:
                        !_vm.selectedRoomsToCancel.length &&
                        _vm.isMultiRoomReservation,
                    },
                    on: {
                      click: _vm.cancel,
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.cancel($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.cancel($event)
                        },
                      ],
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.ModifyReservationPopupCancelButtonLabel)
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }